import { styled } from '@mui/material/styles';

import { rem, Theme } from '../../theme';

export const StyledLink = styled('a')`
    ${({ theme }: { theme: Theme }) =>
        theme.isRebranding('', theme.typography.linkWithChevron)};
    ${({ theme }: { theme: Theme }) => `
        color:${theme.isRebranding(theme.palette.common.blue, theme.palette.tgg.text.action.main)};
        display:${theme.isRebranding('block', 'flex')};
        align-items: center;
        :focus-visible {
            outline: none;
            }
        svg {
        margin-bottom: ${theme.tggSpacing(rem(0.1), 0)};
            width: ${theme.tggSpacing('unset', 6)};
            height: ${theme.tggSpacing('unset', 6)};
        }
             path{
             fill:${theme.isRebranding(theme.palette.primary.main, theme.palette.tgg.text.action.main)};
             }
	`}
`;
